import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function PricingTable(props) {
    var _cell_buttonClass;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("pt-11 pb-5 md:pb-4 px-6 md:px-14 mb-10 knime-hidden md:block", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-center text-3xl leading-tight md:text-4xl lg:text-[40px] mb-4 md:mb-8 lg:mb-14"
    }, (props === null || props === void 0 ? void 0 : props.heading) ? props.heading : "Find which plan is right for you"), /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:pt-6 md:gap-x-6 lg:gap-x-10 w-full bg-white z-10 sticky top-[68px] lg:top-[90px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:w-2/5 text-center mb-2 relative pb-9 overflow-hidden"
    }, /*#__PURE__*/ React.createElement(BlueLineShort, null), /*#__PURE__*/ React.createElement("h3", {
        className: "font-medium text-xl lg:text-3xl mb-1"
    }, (props === null || props === void 0 ? void 0 : props.communityTitle) ? props.communityTitle : "KNIME Community Hub"), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-200 block lg:text-lg"
    }, (props === null || props === void 0 ? void 0 : props.communitySubtitle) ? props.communitySubtitle : "Managed by KNIME")), /*#__PURE__*/ React.createElement("div", {
        className: "md:w-3/5 text-center mb-2 relative pb-9 overflow-hidden"
    }, /*#__PURE__*/ React.createElement(BlueLineLong, null), /*#__PURE__*/ React.createElement("h3", {
        className: "font-medium text-xl lg:text-3xl mb-1"
    }, (props === null || props === void 0 ? void 0 : props.businessTitle) ? props.businessTitle : "KNIME Business Hub"), /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-200 block lg:text-lg"
    }, (props === null || props === void 0 ? void 0 : props.businessSubtitle) ? props.businessSubtitle : "Installed in Customer Infrastructure"))), /*#__PURE__*/ React.createElement("div", {
        className: 'relative before:hidden before:xl:block before:content-[""] before:w-6 before:h-full before:absolute before:left-[calc(40%+35px)] before:top-0 before:bg-white'
    }, /*#__PURE__*/ React.createElement("table", {
        className: "w-full price-table"
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("th", {
        className: "px-4 py-5 bg-white sticky top-[184px] lg:top-[226px]"
    }), props.topHeadings.map(function(heading, index) {
        return /*#__PURE__*/ React.createElement("th", {
            key: index,
            className: clsx("sticky top-[184px] lg:top-[226px] bg-white px-4 py-7 font-heading font-semibold lg:text-xl", {
                "pr-8": index === 1,
                "pr-4": index !== 1
            })
        }, heading);
    }))), /*#__PURE__*/ React.createElement("tbody", null, props.table.rows.map(function(row, rowIndex) {
        /*#__PURE__*/ return React.createElement("tr", {
            key: rowIndex,
            className: "group hover:bg-gray-30 transition-all duration-200"
        }, /*#__PURE__*/ React.createElement("th", {
            scope: "row",
            className: "pr-4 py-6 border-b-2 border-b-gray-400 text-xs w-28 font-normal text-left table-sideheading"
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: row.sideHeading
        })), row.cells.map(function(cell, index) {
            var _cell_button;
            /*#__PURE__*/ return React.createElement("td", {
                key: index,
                className: clsx("pl-4 py-6 text-center text-sm lg:text-base border-b-2 border-b-gray-400 w-[18%] font-heading font-medium", {
                    "pr-8": index === 1,
                    "pr-4": index !== 1,
                    "!px-1": cell.button
                })
            }, cell.button ? /*#__PURE__*/ React.createElement("a", {
                id: ((_cell_button = cell.button) === null || _cell_button === void 0 ? void 0 : _cell_button.id) || "pricing-".concat(props.topHeadings[index].toLowerCase()),
                href: cell.button.target,
                className: clsx((_cell_buttonClass = cell.buttonClass) !== null && _cell_buttonClass !== void 0 ? _cell_buttonClass : "", {
                    "button-secondary max-[1023px]:px-3 focus bg-white border-gray-600 text-gray-600 hover:bg-gray-600 hover:border-gray-600 hover:text-white": cell.button.display === "PRIMARY",
                    "button-secondary max-[1023px]:px-3 focus border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white": cell.button.display === "SECONDARY"
                })
            }, cell.button.label) : cell.text ? cell.text : cell.isChecked ? /*#__PURE__*/ React.createElement(TickIcon, null) : "");
        }));
    }))))));
}
function TickIcon() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28px",
        height: "21px",
        viewBox: "0 0 28 21",
        version: "1.1",
        className: "mx-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Checkmark"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-266.000000, -1950.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Plans-Feature-Table",
        transform: "translate(75.000000, 1348.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Checkmark",
        transform: "translate(191.463956, 595.606813)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1.5360441,6.39318695 L5.5360441,6.39318695 L5.5360441,16.678187 L25.5360441,16.6789012 L25.5360441,20.6789012 L1.5360441,20.6789012 L1.5360441,6.39318695 Z",
        id: "Combined-Shape",
        transform: "translate(13.536044, 13.536044) rotate(-45.000000) translate(-13.536044, -13.536044) "
    }))))));
}
function BlueLineShort() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "521px",
        height: "101px",
        viewBox: "0 0 521 101",
        version: "1.1",
        className: "absolute bottom-0 left-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Line/Lighter Blue"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-74.000000, -1475.000000)",
        stroke: "#D0ECEF",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Plans-Feature-Table",
        transform: "translate(75.000000, 1348.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Title/Community-Hub",
        transform: "translate(0.000000, 127.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Angle-Line/Lighter-Blue",
        transform: "translate(260.000000, 50.000000) rotate(-90.000000) translate(-260.000000, -50.000000) ",
        points: "210.5 309.5 210 -147.808232 269.146478 -209.501556 310 -209.501556"
    })))))));
}
function BlueLineLong() {
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "741px",
        height: "100px",
        viewBox: "0 0 741 100",
        version: "1.1",
        className: "absolute bottom-0 left-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Line/Light Blue"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pricing-Page",
        transform: "translate(-625.000000, -1476.000000)",
        stroke: "#9CD0DE",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Plans-Feature-Table",
        transform: "translate(75.000000, 1348.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Title/Business-Hub",
        transform: "translate(550.000000, 128.000000)"
    }, /*#__PURE__*/ React.createElement("polyline", {
        id: "Angle-Line/Light-Blue",
        transform: "translate(371.000000, 49.500000) rotate(-90.000000) translate(-371.000000, -49.500000) ",
        points: "321.5 419.5 321.5 -259.253069 380.055013 -320.5 420.5 -320.5"
    }))))));
}
